module.exports = __webpack_public_path__ + "media/10.82b6caf9.mp3";